import React, { useEffect, useState, useMemo } from 'react'
import styled from "styled-components"
import {useSelector, useDispatch} from "react-redux"
import {setPlaylist} from "../../actions/set-Playlist"
import {setGroupList} from "../../actions/set-Group"
import {resetMemory} from "../../other/last-opened-mode"
import {loadGroup,loadPlaylist} from "../../other/load-playlist"
import {useParams, useHistory, Route, Switch, useLocation} from "react-router-dom";
import { FixedSizeGrid as Grid } from 'react-window';
import BackgroundPlayer from "./BackgroundPlayer"
import GroupRow from "./GroupRow"
import MoreInfo from "./MoreInfo"
import RowItem from "./RowItem"
import PlayerVod from "./PlayerVod"
import PlayerSeries from "../Series/PlayerSeries"

const Container = styled.div`
    height: 100vh;
    overflow: hidden;
    background-color: #0a0a0a;
    padding-top: 5rem;
    color: white;
    transition: filter 0.5s ease;
    box-sizing: border-box;
`

const ScrollContainer = styled.div`
    height: calc(100vh - 5rem);
    overflow-y: auto;
    width: 100%;
    padding-bottom: 150px;
`

const MainVod = () => {
    const { category, playingMode } = useParams();
    const [playlist, setPlaylistState] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const categories = useSelector(state => state.groupsList) || [];
    const [randomMovie, setRandomMovie] = useState();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const columnCount = useMemo(() => {
        if (windowWidth > 1400) return 7;
        if (windowWidth > 1100) return 5;
        if (windowWidth > 800) return 4;
        if (windowWidth > 500) return 3;
        return 2;
    }, [windowWidth]);

    const rowCount = Math.ceil(playlist.length / columnCount);

    // Otimização de Performance: Agrupa a playlist por categoria uma única vez
    const playlistByCategory = useMemo(() => {
        const map = {};
        playlist.forEach(item => {
            if (!item) return;
            const catId = item.category_id;
            if (!map[catId]) map[catId] = [];
            if (map[catId].length < 15) map[catId].push(item); // Só precisamos de 15 para a Home
        });
        return map;
    }, [playlist]);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const reset = resetMemory(playingMode);

            if (reset === true) {
                const gps = await loadGroup(playingMode);
                if (Array.isArray(gps)) {
                    gps.unshift({category_id:"fav", favorite:1, category_name: "Apenas Favoritos"},{category_id:"toend", history: 1, category_name:"Continuar assistindo"})
                    dispatch(setGroupList(gps));
                }
            }

            // Se for Home (!category), tentamos carregar apenas a playlist se ela estiver vazia
            // No modo PRO, o ALL é pesado. Se já tivermos dados, evitamos recarregar ALL.
            const targetCategory = category || "ALL";
            
            const chs = await loadPlaylist(playingMode, targetCategory);
            if (Array.isArray(chs)) {
                dispatch(setPlaylist(chs));
                setPlaylistState(chs);
                if (chs.length > 0) setRandomMovie(chs[Math.floor(Math.random() * Math.min(chs.length, 10))]);
            }
            setIsLoading(false);
        };
        fetchData();
    }, [playingMode, category, dispatch]);

    const Cell = ({ columnIndex, rowIndex, style }) => {
        const index = rowIndex * columnCount + columnIndex;
        const item = playlist[index];
        if (!item) return null;

        return (
            <RowItem 
                style={style}
                stream_id={item.stream_id || item.series_id} 
                stream_icon={item.stream_icon || item.cover} 
                name={item.name} 
                playingMode={playingMode} 
                category_id={category}
            />
        );
    };

    const isModalOpen = location.pathname.match(/info|play/);

    return (
        <div>
            <Route path="/:playingMode/">
                <Container style={isModalOpen ? {filter: "blur(10px)", pointerEvents: "none"} : {}}>
                    {isLoading && <div style={{textAlign:'center', color:'#00d2ff', padding:'50px', position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)', zIndex:100}}>Carregando...</div>}
                    
                    {!category || isNaN(category) ? (
                        <ScrollContainer>
                            {randomMovie && <BackgroundPlayer image={randomMovie.stream_icon || randomMovie.cover} />}
                            {categories.map(cat => {
                                // Usamos o mapa pré-processado para ser instantâneo
                                const rowPlaylist = playlistByCategory[cat.category_id] || [];
                                if (rowPlaylist.length === 0) return null;
                                return (
                                    <GroupRow 
                                        key={cat.category_id} 
                                        category_id={cat.category_id} 
                                        name={cat.category_name} 
                                        isSeries={playingMode === "series"} 
                                        playlist={rowPlaylist} 
                                    />
                                );
                            })}
                        </ScrollContainer>
                    ) : (
                        <div style={{ padding: '0 20px', height: 'calc(100vh - 5rem)' }}>
                            <Grid
                                columnCount={columnCount}
                                columnWidth={windowWidth / columnCount}
                                height={window.innerHeight - 80}
                                rowCount={rowCount}
                                rowHeight={280}
                                width={windowWidth}
                            >
                                {Cell}
                            </Grid>
                        </div>
                    )}
                </Container>

                <Switch>
                    <Route path="/movie/category/:category/:stream_id/play/">
                        <PlayerVod/>
                    </Route>
                    <Route path="/series/category/:category/:stream_id/play/season/:season/episode/:episode/">
                        <PlayerSeries/>
                    </Route>
                    <Route path="/:playingMode/category/:category/:stream_id/info/">
                        <MoreInfo/>
                    </Route>
                </Switch>
            </Route>
        </div>
    )
}

export default MainVod;
